// extracted by mini-css-extract-plugin
export var article = "services-module--article--14KUN";
export var body = "services-module--body--2mUbx";
export var articleNavigation = "services-module--articleNavigation--2tpmF";
export var container = "services-module--container--2DCFD";